<template>
<b-modal ref="setCentreModal"
  centered
  title="Zmiana centrum widoku"
  :visible="centreWindowVisible"
  @hidden="hide"
  @show="onShow">
  <b-form>
    <b-form-group>
      <b-form-row>
        <b-col>
          <b-alert :show="showAlertMessage" variant="danger" class="mb-0">
            <strong>Uwaga.</strong> {{alertMessage}}
          </b-alert>
        </b-col>
      </b-form-row>
    </b-form-group>
    <b-form-group label="Układ współrzędnych:" label-for="coordinate-system">
      <b-form-row>
        <b-col md="10" offset-md="1">
          <b-form-select id="coordinate-system"
            :options="coordinateSystems"
            value-field="epsg"
            text-field="name"
            v-model="coordinateSystem">
          </b-form-select>
        </b-col>
      </b-form-row>
    </b-form-group>
    <fieldset>
      <b-form-group label="Współrzędne dziesiętne:">
        <b-form-group>
          <b-form-row>
            <b-col md="1" offset-md="1">
              <label class="col-form-label" for="x-coordinate">X</label>
            </b-col>
            <b-col md="9">
              <b-form-input id="x-coordinate" ref="xCoordinate" v-model="xCoordinate" class="form-control" :class="{ 'is-invalid' : xCoordinateInvalid }" type="number" step="0.0001" v-bind:placeholder="placeholder(xAxis=true)" @input="checkChar"/>
            </b-col>
          </b-form-row>
        </b-form-group>
        <b-form-group>
          <b-form-row>
            <b-col md="1" offset-md="1">
              <label class="col-form-label" for="y-coordinate">Y</label>
            </b-col>
            <b-col md="9">
            <b-form-input id="y-coordinate" ref="yCoordinate" v-model="yCoordinate" class="form-control" :class="{ 'is-invalid' : yCoordinateInvalid }" type="number" step="0.0001" v-bind:placeholder="placeholder(xAxis=false)" @input="checkChar"/>
            </b-col>
          </b-form-row>
        </b-form-group>
      </b-form-group>
    </fieldset>
  </b-form>
  <div slot="modal-footer">
    <b-btn variant="primary" @click="setCentre">Zastosuj</b-btn>
    <b-btn variant="outline-secondary" @click="hide">Anuluj</b-btn>
  </div>
</b-modal>
</template>

<script>
import { mapGetters } from "vuex";
import { CoordinateSystems } from "../common/mapEnums";
import { WINDOW_SET_CENTRE_HIDE } from "../store/mutations.type";
import { defaultCoreCipherList } from 'constants';

export default {
  name: "SetCentreWindow",
  data: function() {
    return {
      coordinateSystems: CoordinateSystems,
      coordinateSystem: undefined,
      xCoordinate: undefined,
      yCoordinate: undefined,
      xCoordinateInvalid: false,
      yCoordinateInvalid: false,
      coordinatesGiven: true,
      coordinateSystemGiven: true
    };
  },
  computed: {
    ...mapGetters(["centreWindowVisible"]),
    alertMessage() {
      if (this.xCoordinateInvalid && this.yCoordinateInvalid) return "Współrzędne X i Y są niepoprawne.";
      else if (this.xCoordinateInvalid) return "Współrzędna X jest niepoprawna.";
      else if (this.yCoordinateInvalid) return "Współrzędna Y jest niepoprawna.";
      else if (!this.coordinateSystemGiven) return "Nie podano układu współrzędnych";
      else if (!this.coordinatesGiven) return "Nie podano kompletu współrzędnych.";
      else return null;
    },
    showAlertMessage() {
      return !!this.alertMessage;
    }
  },
  methods: {
    checkChar(value){
      if(value!=""){
        if(event.target.id==this.$refs.xCoordinate.id){
          this.xCoordinate=parseFloat(value);
        }
        if(event.target.id==this.$refs.yCoordinate.id){
          this.yCoordinate=parseFloat(value);
        }
      }
    },
    setCentre() {
      this.clearErrors();

      if (this.coordinateSystem === undefined) {
        this.coordinateSystemGiven = false;
        return;
      }

      const boundsForXAxis = this.getBoundsForAxis(true);
      const boundsForYAxis = this.getBoundsForAxis(false);

      if (this.xCoordinate === undefined || this.xCoordinate === "" || this.yCoordinate === undefined || this.yCoordinate === "") {
        this.coordinatesGiven = false;
        return;
      }

      const xCoordinate = parseFloat(this.xCoordinate);
      const yCoordinate = parseFloat(this.yCoordinate);

      if (xCoordinate < boundsForXAxis.min || boundsForXAxis.max < xCoordinate)
        this.xCoordinateInvalid = true;

      if (yCoordinate < boundsForYAxis.min || boundsForYAxis.max < yCoordinate)
        this.yCoordinateInvalid = true;

      if (this.xCoordinateInvalid || this.yCoordinateInvalid) return;

      let args = { coordinateSystem: this.coordinateSystem, x: xCoordinate, y: yCoordinate };
      this.hide()

      this.$emit("set-centre", args);
    },
    getBoundsForAxis(xAxis) {
      if (this.coordinateSystem) {
        const system = this.coordinateSystems.find( x => x.epsg == this.coordinateSystem);
        const min = xAxis ? system.minx : system.miny;
        const max = xAxis ? system.maxx : system.maxy;
        return { min: min, max: max };
      }
    },
    clearErrors() {
      this.xCoordinateInvalid = false;
      this.yCoordinateInvalid = false;
      this.coordinateSystemGiven = true;
      this.coordinatesGiven = true;
    },
    placeholder(xAxis) {
      const boundsForAxis = this.getBoundsForAxis(xAxis);

      if (boundsForAxis) return `Min: ${boundsForAxis.min}, Max: ${boundsForAxis.max}`;

      return "";
    },
    hide() {
      this.$store.commit(WINDOW_SET_CENTRE_HIDE);
    },
    onShow() {
      this.coordinateSystem = undefined;
      this.xCoordinate = undefined;
      this.yCoordinate = undefined;
      this.clearErrors();
    }
  }
};
</script>
